import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  recuperarPessoa: function(usuario) {
    return Vue.http.post('/api/login/recuperarpessoa', usuario);
  },
  recuperarPessoaWeb: function (usuario) {
    return Vue.http.post('/api/login/recuperarpessoaweb', usuario);
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/recuperar-senha-pessoa-fisica/servico.js